import { Outlet,Navigate } from "react-router-dom";
import axios from "axios";
import { useState, useEffect, use } from "react";
import { useAuth } from "./Auth";


let isAdmin;

const ProtectedAdminRoute = () => {
    const auth = useAuth();
    
    isAdmin = auth.isAdmin;
    return isAdmin ?  <Outlet/> : <Navigate to="/login"/>
}

export default ProtectedAdminRoute